export default __webpack_public_path__ + "static/media/fifgroup.d43cd387.svg";